function parseBooleanEnv(value: string | undefined): boolean | undefined {
  if (typeof value !== 'string') return undefined;
  const normalized = value.trim().toLowerCase();
  if (!normalized) return undefined;
  if (['1', 'true', 'yes', 'on'].includes(normalized)) return true;
  if (['0', 'false', 'no', 'off'].includes(normalized)) return false;
  return undefined;
}

export function isWordPressMcpEnabledServer(): boolean {
  return (
    parseBooleanEnv(process.env.WORDPRESS_MCP_ENABLED) ??
    parseBooleanEnv(process.env.NEXT_PUBLIC_WORDPRESS_MCP_ENABLED) ??
    false
  );
}

export function isWordPressMcpEnabledClient(): boolean {
  return parseBooleanEnv(process.env.NEXT_PUBLIC_WORDPRESS_MCP_ENABLED) ?? false;
}

export function assertWordPressMcpEnabled(): void {
  if (!isWordPressMcpEnabledServer()) {
    throw new Error('WordPress.com MCP integration is not enabled');
  }
}
